import axios from 'axios';

const DEVICE_ID_KEY = 'loq-chl:deviceId';

let pendingDeviceIdRequest: Promise<string> | null = null;

function isValidDeviceId(deviceId: string | null): deviceId is string {
  return typeof deviceId === 'string' && !deviceId.match(/[_[\] ]/g);
}

export default async function getDeviceId(baseUrl: string, language: string) {
  const storedDeviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (isValidDeviceId(storedDeviceId)) {
    return storedDeviceId;
  }

  if (!pendingDeviceIdRequest) {
    pendingDeviceIdRequest = registerDevice(baseUrl, language)
      .then((deviceId) => {
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
        return deviceId;
      })
      .finally(() => {
        pendingDeviceIdRequest = null;
      });
  }

  return pendingDeviceIdRequest;
}

async function registerDevice(baseUrl: string, language: string) {
  const client = axios.create();
  const response = await client.post(`${baseUrl}/register-device`, undefined, {
    headers: {
      'Accept-Language': language,
      'X-Loquis-App-Platform': 'web',
    },
  });
  const deviceId = response.data?.result ?? response.data;

  if (!isValidDeviceId(deviceId)) {
    throw new Error('Invalid device id response');
  }

  return deviceId;
}
